// Detects whether the app is running inside the Debii Android TWA (Trusted Web
// Activity). A TWA sets document.referrer to "android-app://<packageId>".
// We also honour a persisted ?twa=1 flag so the behaviour can be verified in a
// normal browser during Preview testing. The live website (opened in a browser)
// is never treated as the Android app, so web behaviour is unchanged.
const TWA_PACKAGE = "com.debiiapp.app";

export function isAndroidApp() {
  try {
    if (typeof window === "undefined") return false;

    // Persisted test/override flag (Preview only).
    const params = new URLSearchParams(window.location.search);
    if (params.get("twa") === "1") {
      window.localStorage.setItem("debii_twa", "1");
    }
    if (window.localStorage.getItem("debii_twa") === "1") return true;

    // Real TWA signal.
    if (document.referrer && document.referrer.startsWith(`android-app://${TWA_PACKAGE}`)) {
      return true;
    }
    return false;
  } catch {
    return false;
  }
}
